import {
  createRequestTypes,
  START,
  SUCCESS,
  ERROR,
} from '@modules/appraisal/actions/global';
import { makeApiActionCreatorV3 } from '@actions/utils';

import * as api from '../api/arbitrationProperties';

const namespace = 'ARBITRATION_PROPERTIES';

export const FETCH_PROPERTIES_START = `${namespace}/FETCH_PROPERTIES_START`;
export const FETCH_PROPERTIES_SUCCESS = `${namespace}/FETCH_PROPERTIES_SUCCESS`;
export const FETCH_PROPERTIES_ERROR = `${namespace}/FETCH_PROPERTIES_ERROR`;

export const fetchProperties = makeApiActionCreatorV3(
  api.fetchProperties,
  FETCH_PROPERTIES_START,
  FETCH_PROPERTIES_SUCCESS,
  FETCH_PROPERTIES_ERROR,
);

export const INSERT_ARBITRATION_PROPERTY = createRequestTypes(
  `${namespace}/INSERT_ARBITRATION_PROPERTY`,
);
export const insertArbitrationProperty = makeApiActionCreatorV3(
  api.insertArbitrationProperty,
  INSERT_ARBITRATION_PROPERTY[START],
  INSERT_ARBITRATION_PROPERTY[SUCCESS],
  INSERT_ARBITRATION_PROPERTY[ERROR],
);

export const DELETE_ARBITRATION_PROPERTY = createRequestTypes(
  `${namespace}/DELETE_ARBITRATION_PROPERTY`,
);
export const deleteArbitrationProperty = makeApiActionCreatorV3(
  api.deleteArbitrationProperty,
  DELETE_ARBITRATION_PROPERTY[START],
  DELETE_ARBITRATION_PROPERTY[SUCCESS],
  DELETE_ARBITRATION_PROPERTY[ERROR],
);

export const UPDATE_ARBITRATION_PROPERTY = createRequestTypes(
  `${namespace}/UPDATE_ARBITRATION_PROPERTY`,
);
export const updateArbitrationProperty = makeApiActionCreatorV3(
  api.updateArbitrationProperty,
  UPDATE_ARBITRATION_PROPERTY[START],
  UPDATE_ARBITRATION_PROPERTY[SUCCESS],
  UPDATE_ARBITRATION_PROPERTY[ERROR],
);

export const UPDATE_ARBITRATION_PROPERTY_FINAL_VALUE = createRequestTypes(
  `${namespace}/UPDATE_ARBITRATION_PROPERTY_FINAL_VALUE`,
);
export const updateArbitrationPropertyFinalValue = makeApiActionCreatorV3(
  api.updateArbitrationPropertyFinalValue,
  UPDATE_ARBITRATION_PROPERTY_FINAL_VALUE[START],
  UPDATE_ARBITRATION_PROPERTY_FINAL_VALUE[SUCCESS],
  UPDATE_ARBITRATION_PROPERTY_FINAL_VALUE[ERROR],
);

export const DISTRIBUTE_PRORATA = createRequestTypes(
  `${namespace}/DISTRIBUTE_PRORATA`,
);
export const distributeArbitrationProrata = makeApiActionCreatorV3(
  api.distributeArbitrationProrata,
  DISTRIBUTE_PRORATA[START],
  DISTRIBUTE_PRORATA[SUCCESS],
  DISTRIBUTE_PRORATA[ERROR],
);

export const SET_ARBITRATION_PROPERTY_FILED_TIMELY = createRequestTypes(
  `${namespace}/SET_ARBITRATION_PROPERTY_FILED_TIMELY`,
);
export const setArbitrationPropertyFiledTimely = makeApiActionCreatorV3(
  api.setArbitrationPropertyFiledTimely,
  SET_ARBITRATION_PROPERTY_FILED_TIMELY[START],
  SET_ARBITRATION_PROPERTY_FILED_TIMELY[SUCCESS],
  SET_ARBITRATION_PROPERTY_FILED_TIMELY[ERROR],
);

export const SET_ARBITRATION_PROPERTY_TAXES_PAID = createRequestTypes(
  `${namespace}/SET_ARBITRATION_PROPERTY_TAXES_PAID`,
);
export const setArbitrationPropertyTaxesPaid = makeApiActionCreatorV3(
  api.setArbitrationPropertyTaxesPaid,
  SET_ARBITRATION_PROPERTY_TAXES_PAID[START],
  SET_ARBITRATION_PROPERTY_TAXES_PAID[SUCCESS],
  SET_ARBITRATION_PROPERTY_TAXES_PAID[ERROR],
);